<template>
  <div class="show-box" style="height: 100%;overflow: auto;background-color: #f3f5f7;" v-loading="isLoading">
    <div class="funbar" :style="{width: panelWidth}" v-if="showNav && config && config !== null">
      <div class="funbar-wrap clearfix">
        <div class="label-text mr10 pull-left" v-if="config.label && config.label !== ''">
          <span>{{config.label}}</span>
        </div>
        <div class="pull-right mr10" v-if="canBack">
          <el-button @click="back" type="primary" icon="el-icon-back" size="mini">返回</el-button>
        </div>
        <div class="pull-left mr10" v-for="condition in config.conditions">
          <el-tooltip open-delay="200" effect="dark" :content="condition.label" placement="bottom">
            <el-date-picker
              v-if="condition.type === 'dateLimit'"
              v-model="search[condition.dataIndex]"
              type="daterange"
              size="mini"
              align="right"
              unlink-panels
              range-separator="至"
              style="width: 210px;"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeSearch"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-select
              v-if="condition.type === 'select'"
              v-model="search[condition.dataIndex]"
              filterable
              clearable
              size="mini"
              @change="changeSearch"
              :placeholder="'请选择' + condition.label">
              <el-option
                v-for="item in condition.options"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
            <el-cascader
              v-if="condition.type === 'treeSelect'"
              v-model="search[condition.dataIndex]"
              :options="condition.options"
              :props="cascadeProps"
              :show-all-levels="false"
              size="mini"
              :collapse-tags="true"
              @visible-change="cascadeVisible"
              @remove-tag="cascadeRemoveTag"
              :placeholder="'请选择' + condition.label">
            </el-cascader>
            <!-- 多选 -->
            <el-select v-if="condition.type === 'multiSelect'"
                       multiple
                       collapse-tags
                       v-model="search[condition.dataIndex]"
                       filterable
                       clearable
                       size="mini"
                       @remove-tag="removeTag"
                       @visible-change="visibleChange"
                       :placeholder="'请选择' + condition.label">
              <el-option
                v-for="item in condition.options"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-tooltip>
        </div>
        <div class="pull-right mr10">
          <el-tooltip class="item" open-delay="200" effect="dark" :content="'点击刷新'" placement="bottom">
            <i class="el-icon-refresh refresh-btn" @click="loadBoard"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="stat" :style="{marginTop: showNav ? '62px' : '0'}">
      <template v-if="config !== null">
        <div class="block" v-for="block in config.blockConfigs"
             :style="{width: 100 / block.colNum + '%', minWidth: minWidth / block.colNum}">
          <analyse-block :search="search" :block="block.blockConfig"></analyse-block>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import AnalyseBlock from './analyse-block'
  import analyseUtil from './analyse-util'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    components: {AnalyseBlock},
    props: {
      id: {
        type: String
      },
      extSearch: {
        type: Object
      },
      showNav: {
        type: Boolean,
        default: true
      }
    },
    name: 'analyse-board',
    data() {
      return {
        isLoading: false,
        config: null,
        minWidth: 1000,
        panelWidth: '100%',
        search: this.extSearch && this.extSearch !== null ? this.extSearch : {},
        cascadeProps: {
          value: 'id',
          multiple: true,
          checkStrictly: false,
          emitPath: false
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '本月',
            onClick(picker) {
              // 本月第一天
              const start = new Date()
              start.setDate(1)
              // 本月最后一天  下个月的第一天的前一天就是本月最后一天
              const end = new Date(start)
              end.setMonth(end.getMonth() + 1)
              end.setDate(0)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '上月',
            onClick(picker) {
              // 上个月第一天
              const start = new Date()
              start.setDate(1)
              start.setMonth(start.getMonth() - 1)
              // 上个月最后一天
              const end = new Date()
              end.setDate(0)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 1000 * 3600 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '本年',
            onClick(picker) {
              // 设置日期为当前年的第一天
              const start = new Date()
              start.setDate(1)
              start.setMonth(0)
              // 设置日期为当前年的最后一天
              const end = new Date()
              end.setMonth(11)
              end.setDate(31)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '上年',
            onClick(picker) {
              // 设置日期为上年的第一天
              const start = new Date()
              start.setDate(1)
              start.setMonth(0)
              start.setFullYear(start.getFullYear() - 1)
              // 设置日期为上年的最后一天
              const end = new Date(start)
              end.setMonth(11)
              end.setDate(31)
              picker.$emit('pick', [start, end])
            }
          }
          ]
        },
        canBack: this.$route.query && this.$route.query.deep
      }
    },
    beforeRouteUpdate(to, from, next) {
      analyseUtil.adjustStack(this.$route.query && this.$route.query.deep ? this.$route.query.deep : 0, this)
      next()
    },
    activated() {
      analyseUtil.adjustStack(this.$route.query && this.$route.query.deep ? this.$route.query.deep : 0, this)
    },
    mounted() {
      if (this.getConfigUrl() && this.getConfigUrl() !== null) {
        this.loadBoard()
      }
      addResizeListener(this.$el, this.resizeListener)
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.resizeListener)
    },
    methods: {
      removeTag: function () {
        this.$nextTick(() => this.changeSearch())
      },
      visibleChange: function (visible) {
        if (!visible) {
          this.changeSearch()
        }
      },
      cascadeVisible: function (visible) {
        if (!visible) {
          this.changeSearch()
        }
      },
      cascadeRemoveTag: function () {
        this.$nextTick(() => this.changeSearch())
      },
      changeSearch: function () {
        analyseUtil.putBoardSearch(this.search, this)
        this.loadBoard()
      },
      getConfigUrl: function () {
        let boardId = this.id ? this.id : (this.$route.query && this.$route.query.id ? this.$route.query.id : null)
        let parentId = this.$route.query && this.$route.query.parentId ? 'parentId=' + this.$route.query.parentId : ''
        if (boardId && boardId !== null && boardId !== '') {
          return '/entity/analyse/analyseBoard/board/' + boardId + '?' + parentId
        } else if (this.$route.meta.url) {
          return this.$route.meta.url
        }
      },
      resizeListener: function () {
        this.$nextTick(() => {
          if (document.getElementsByClassName('stat')[0]) {
            this.panelWidth = document.getElementsByClassName('stat')[0].offsetWidth + 'px'
          }
          setTimeout(() => {
            this.panelWidth = document.getElementsByClassName('stat')[0].offsetWidth + 'px'
          }, 1000)
        })
      },
      loadBoard: function () {
        this.isLoading = true
        this.config = null
        this.$nextTick(() => {
          util.ajax.get(this.getConfigUrl()).then(res => {
            if (res.data.meta && res.data.meta.errCode === 0) {
              this.setParentSearch()
              this.setDefaultValue(res.data.data)
              this.setHistorySearch(res.data.data)
              this.config = res.data.data
            } else {
              this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
            }
            this.isLoading = false
          }).catch(err => {
            this.isLoading = false
            console.error(err)
            this.$notify.error({title: '错误', message: '系统错误'})
          })
        })
      },
      back: function () {
        let params = {}
        if (this.$route.query && this.$route.query !== null && this.$route.query.deep) {
          let deep = parseInt(this.$route.query.deep) - 1
          if (deep > 0) {
            params.deep = deep
          }
        }
        util.routerBack(this, undefined, params)
      },
      setHistorySearch: function (data) {
        let historySearch = analyseUtil.getBoardSearch(this)
        if (historySearch === null || Object.keys(historySearch).length === 0) {
          return
        }
        for (let i = 0; i < data.conditions.length; i++) {
          if (historySearch[data.conditions[i].dataIndex] === undefined) {
            continue
          }
          this.$set(this.search, data.conditions[i].dataIndex, historySearch[data.conditions[i].dataIndex])
        }
      },
      setParentSearch: function () {
        analyseUtil.adjustStack(this.$route.query && this.$route.query.deep ? this.$route.query.deep : 0, this)
        if (Object.keys(this.search).length > 0) {
          return
        }
        if (analyseUtil.peekSearchStack(this)) {
          this.search = {...this.search, ...analyseUtil.peekSearchStack(this).search}
        }
      },
      setDefaultValue: function (data) {
        for (let i = 0; i < data.conditions.length; i++) {
          if (this.search[data.conditions[i].dataIndex] && this.search[data.conditions[i].dataIndex] !== null) {
            continue
          }
          this.$set(this.search, data.conditions[i].dataIndex, data.conditions[i].defaultValue)
        }
      }
    }
  }
</script>
<style scoped>

  .label-text {
    padding: 3px 15px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #222;
    line-height: 28px;
  }

  .stat {
    padding: 0 10px;
    min-width: 1000px;
  }

  .block {
    display: inline-block;
    min-height: 140px;
  }

  .funbar {
    position: fixed;
    z-index: 999;
    width: 100%;
    background-color: white;
    border-bottom: 1px solid #ddd;
  }

  .funbar-wrap {
    padding: 10px;
  }

  .pull-left {
    float: left !important;
  }

  .pull-right {
    float: right !important;
  }

  .input-icon i {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 16px;
    vertical-align: middle;
  }

  .refresh-btn {
    font-size: 20px;
    cursor: pointer;
    line-height: 27px;
  }

  .refresh-btn:hover {
    color: #006DE7;
  }

</style>
<style>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/analyse-board.vue